import Spectator from './Spectator';

export default Spectator;
